module.exports = __webpack_public_path__ + "static/media/Alpha-iQ-OA-6400-iQ.a2fa0bf5.png";